import api from "../instance/axios_instance.ts";
const CustomerTypeApi = async (): Promise<any> => {

    try {
        const response = await api.get('/customer_type', { skipAuth: true } as any);
        return response.data;
    } catch (error) {
        const mensajeError = error.response?.data?.message;
        throw new Error(mensajeError || 'Error credito');
    }
};

export default CustomerTypeApi;